var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRacing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.607,
    height: 17.348,
    viewBox: "0 0 16.607 17.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.124,
    y1: 0.5,
    x2: 0.938,
    y2: 0.748,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3896d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#3896d5",
    stopOpacity: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#3896d5",
    stopOpacity: 0.624
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3896d5",
    stopOpacity: 0.4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37618",
    "data-name": "Path 37618",
    d: "M1310.416,817.1l-9.657,3.212c-1.824-1.846-1.005-4.228.284-4.774a4.992,4.992,0,0,0,1.726-1.311c1.1-1.289.7-3.878.557-4.643a1.622,1.622,0,0,0-.688-1.016,1.538,1.538,0,0,0-1.191-.229c-1.376.295-2.67,2.536-2.67,2.536a8.073,8.073,0,0,0-1.11,1.93c-.094.563.628-.607,1.262-1.373,1.215-1.479,1.644-1.849,2.736-2.078a.545.545,0,0,1,.4.076.6.6,0,0,1,.24.349c.262,1.377.262,3.07-.328,3.769a10.27,10.27,0,0,1-3.43,2.01,7.633,7.633,0,0,0-1.639.83c-.524.426-1.267,1.136-1.682,1.54l-1.1-.83a.777.777,0,0,1-.295-.819,39.688,39.688,0,0,1,3.834-9.078c.131-.251.273-.5.426-.765l.131-.229-.109-.24a2.758,2.758,0,0,0-1.923-1.278,9.371,9.371,0,0,1,4.883-.4,5.57,5.57,0,0,1,.607.147,1.675,1.675,0,0,0,.223,2.321c-.771-1.727.164-2.338.732-2.72.71-.492.765-.579.885-1.071a2.957,2.957,0,0,1,.207,3.529,4.945,4.945,0,0,0,.634-.885,2.186,2.186,0,0,1,.2.142,9.167,9.167,0,0,1,1.672,1.453A14.977,14.977,0,0,1,1310.416,817.1Z",
    transform: "translate(-1293.809 -802.967)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacing);
export default __webpack_public_path__ + "static/media/racing.0a7cde5005d0565aeab4235839570cf6.svg";
export { ForwardRef as ReactComponent };